/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import { createTheme } from "@material-ui/core";
import { theme } from "./theme";

const selectStyleOverrides = {
  MuiSelect: {
    root: {
      border: "2px solid #93A1A9 !important",
      borderRadius: "16px !important",
      fontFamily: theme.fontFamily,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "18px",
      letterSpacing: "-0.2px",
      color: "#48545B",
      background: "#ffffff",
      "&:focus": {
        backgroundColor: "#ffffff !important",
        borderRadius: "16px !important",
        border: "2px solid #93A1A9 !important",
      },
    },
    select: {
      border: "2px solid #93A1A9 !important",
      borderRadius: "16px !important",
      fontFamily: theme.fontFamily,
      fontStyle: "normal !important",
      fontSize: "14px !important",
      lineHeight: "18px !important",
      letterSpacing: "-0.2px !important",
      color: "#48545B !important",
      background: "#ffffff !important",
      "&:focus": {
        backgroundColor: "#ffffff !important",
        borderRadius: "16px !important",
        border: "2px solid #93A1A9 !important",
      },
    },
    selectMenu: {
      borderRadius: "16px",
      border: "2px solid #93A1A9 !important",
      background: "#ffffff",
      "&:focus": {
        backgroundColor: "#ffffff !important",
        borderRadius: "16px !important",
        border: "2px solid #93A1A9 !important",
      },
    },
    icon: {
      fontSize: "2.5em !important",
    },
  },
  MuiOutlinedInput: {
    notchedOutline: {
      border: "none !important",
    },
  },
  MuiMenuItem: {
    root: {
      fontSize: "1em !important",
      fontFamily: theme.fontFamily,
      fontStyle: "normal !important",
      lineHeight: "18px !important",
      letterSpacing: "-0.2px !important",
      color: "#48545B !important",
      background: "#ffffff !important",
    },
  },
};

const selectTheme = createTheme({
  overrides: selectStyleOverrides,
});

export default selectTheme;
